import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/lightmode.css';
import App from './App.jsx';
import ErrorBoundary from './components/common/ErrorBoundary.jsx';
// Explicitly import Firebase first to ensure it initializes before the app
import './firebase';

console.log('Application starting...');
console.log('Firebase has been initialized');

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('Root element found:', document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

console.log('Render called');
